export const InputDefaultClassesMock = ['input'];
export const InputDefaultPropsMock = {};
